import { Component, OnInit, ViewChild, NgZone } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
@Component({
  selector: 'app-add-location',
  templateUrl: './add-location.component.html',
  styleUrls: ['./add-location.component.css']
})
export class AddLocationComponent implements OnInit {
  @ViewChild('modalHide') modalHide;
  
  public addLocationForm:FormGroup;
  public selLocation={};
  public selectedValueClose = false;
  public locationSuggestions={};
  public locationObj = {};

  primaryMap: any;
  mapSearchDebounceTimeOut = null;
  mapSearchDataLists = [];
  markerId = 'pickLocation';
  formSubmit:boolean=false;

  constructor(
    public api: ApiService,
    public swal: SweetAlert,
    public storage: StorageService,
    public router: Router,) { 
  }
  ngOnInit(): void {
    this.addLocationFormLoad();
  }
  
  addLocationFormLoad(){
    this.addLocationForm = new FormGroup({
      title: new FormControl('', [Validators.required]),
      location: new FormControl('', [Validators.required]),
    });
  }

   /* checking error in fields*/

   public checkError = (controlName: string, errorName: string) => {
    return this.addLocationForm.controls[controlName].hasError(errorName);
  }

  getLocation(obj){
    this.selLocation = {...obj};
  }

  cancel(){
    this.router.navigate(['/organization/transport-manager/information/orgInfo/location/view-location']);
  }

  /* submit data*/
  onSubmit(){
    this.formSubmit = true;
    if (this.addLocationForm.valid) {
      const obj = {
        ...this.addLocationForm.value
      };

      delete obj.location;
      obj.location=this.selLocation;
      this.api.transportManagerLocationCreate(obj).then((res: any) => {
        if (res.status == 'success') {

          this.swal.swalFunction(res.status, res.status, res.message, 2000);
          this.router.navigate(['/organization/transport-manager/information/orgInfo/location/view-location'])

        }
        if (res.status == 'failure') {
          this.swal.swalFunction('error', res.status, res.message, 3000);
        }
      }).catch((err) => {
        console.log(err);
      });

    }
  }
}
